
import { AuditInfo } from "./audit-info";
import { Question } from "./question";
import { AuditEntryOptions } from "./audit-entry-options";
import { AuditCompletionInfo } from "./audit-completion-info";
import { AuditMetaData } from "./audit-meta-data";
import { BasicUser } from "../basic-user";
import { AuditHistory } from "./AuditResults/audit-history";

export class FlattenedQuestionHolder{
    AuditID:number = -1;
    AuditName:string = '';
    Questions:Question[] = [];
    AuditInfo:AuditInfo = new AuditInfo();
    AuditEntryOptions:AuditEntryOptions = new AuditEntryOptions();
    AuditCompletionInfo:AuditCompletionInfo = new AuditCompletionInfo();
    AuditMetaData:AuditMetaData = new AuditMetaData();
    ActionUsers:BasicUser[] = [];
    HistoricInfo:AuditHistory[] = [];
    IsEventAudit: boolean = false;
    EventWorkflowID: number = -1;
    constructor(values: Object = {}){
        Object.assign(this, values);   
        if(values.hasOwnProperty('AuditCompletionInfo')){
            this.AuditCompletionInfo = new AuditCompletionInfo((values as FlattenedQuestionHolder)['AuditCompletionInfo'] as AuditCompletionInfo) 
         }          
         if(values.hasOwnProperty('AuditEntryOptions')){
            this.AuditEntryOptions = new AuditEntryOptions((values as FlattenedQuestionHolder)['AuditEntryOptions'] as AuditEntryOptions) 
         }   
         if(values.hasOwnProperty('AuditMetaData')){
            this.AuditMetaData = new AuditMetaData((values as FlattenedQuestionHolder)['AuditMetaData'] as AuditMetaData) 
         }   
         if(values.hasOwnProperty('AuditInfo')){
            this.AuditInfo = new AuditInfo((values as FlattenedQuestionHolder)['AuditInfo'] as AuditInfo) 
         }   
        if(values.hasOwnProperty('Questions')){
            this.Questions = [];
            ((values as FlattenedQuestionHolder)['Questions'] as Question[]).forEach(element => {
                this.Questions.push(new Question(element));
            });
        }
        if(values.hasOwnProperty('ActionUsers')){
            this.ActionUsers = [];
            ((values as FlattenedQuestionHolder)['ActionUsers'] as BasicUser[]).forEach(element => {
                this.ActionUsers.push(new BasicUser(element));
            });
        }
        if(values.hasOwnProperty('HistoricInfo')){
            this.HistoricInfo = [];
            ((values as FlattenedQuestionHolder)['HistoricInfo'] as AuditHistory[]).forEach(element => {
                this.HistoricInfo.push(new AuditHistory(element));
            });
        }
        if (this.Questions.length > 0) {
            this.recomputeNonCompliance();
        }
    }

    private recomputeNonCompliance() {
        this.Questions.forEach(question => {
            question.CompletionInfo.NonCompliant = this.calculateNonCompliance(question);
        });
    }

    private calculateNonCompliance(question: Question): boolean {
        if (question.NASelected || !question.CompletionInfo.QuestionAnswered) {
            return false;
        }

        switch (question.QuestionType?.ID) {
            case 1:
            case 2: {
                const answerId = Number(question.CompletionInfo.Answer);
                if (!Number.isFinite(answerId)) {
                    return false;
                }
                const answer = question.QuestionAnswers.find(e => e.QuestionAnswerID == answerId);
                if (!answer) {
                    return false;
                }
                const failsScore = !question.ExcludeScoreFromTotal && Number(answer.ComplianceScore) <= Number(question.ComplianceLimit);
                return failsScore || answer.Actionable;
            }
            case 3: {
                const answerIds = Array.isArray(question.CompletionInfo.Answer) ? question.CompletionInfo.Answer : [];
                if (answerIds.length == 0) {
                    return false;
                }
                let totalScore = 0;
                let actionable = false;
                answerIds.forEach(id => {
                    const answer = question.QuestionAnswers.find(e => e.QuestionAnswerID == id);
                    if (!answer) {
                        return;
                    }
                    totalScore += Number(answer.ComplianceScore);
                    if (answer.Actionable) {
                        actionable = true;
                    }
                });
                const failsScore = !question.ExcludeScoreFromTotal && totalScore <= Number(question.ComplianceLimit);
                return failsScore || actionable;
            }
            default:
                return false;
        }
    }
}
